import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { getTickmillCompanyNameByType } from 'api/Clients/Types/TickmillCompanyTypes'
import { NameDto } from 'api/Common/Types'
import classNames from 'classnames'
import { formatLocalDateUTC } from 'utils/date'

import { MarketingBonusCampaignKey } from '../../../api/Wallet/Types/MarketingBonusCampaignDto'

import styles from '../../Search/SearchGridResult.module.scss'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const bonusCampaignColumn: GridColumn[] = [
  {
    title: 'Internal Name',
    field: MarketingBonusCampaignKey.internalName,
    show: true,
    className: 'table-columns__content',
  },
  {
    title: 'Bonus Type',
    field: MarketingBonusCampaignKey.bonusType,
    show: true,
    className: 'table-columns__content',
  },
  {
    title: 'Start Date',
    field: MarketingBonusCampaignKey.startDate,
    cell: (gridCellProps: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(gridCellProps.dataItem.startDate, true)}
      </td>
    ),
    show: true,
    className: 'table-columns__date',
    filter: 'text',
  },
  {
    title: 'End Date',
    field: MarketingBonusCampaignKey.endDate,
    cell: (gridCellProps: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(gridCellProps.dataItem.endDate, true)}
      </td>
    ),
    show: true,
    className: 'table-columns__date',
    filter: 'text',
  },
  {
    title: 'Status',
    field: MarketingBonusCampaignKey.status,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'Last Updated',
    field: MarketingBonusCampaignKey.lastUpdatedDate,
    cell: (gridCellProps: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(gridCellProps.dataItem.lastUpdatedDate, true)}
      </td>
    ),
    show: true,
    className: 'transaction-columns__content',
    filter: 'text',
  },
  {
    title: 'Entity',
    cell: (props: GridCellProps): JSX.Element => {
      const tickmillCompanies = props.dataItem?.tickmillCompanies || []
      if (tickmillCompanies.length <= 0) {
        return <td />
      }

      return (
        <td className={classNames(styles.column)}>
          {tickmillCompanies.map((x: NameDto) => (
            <>
              <CompanyTag id={x.id}>{getTickmillCompanyNameByType(x.id)}</CompanyTag>{' '}
            </>
          ))}
        </td>
      )
    },
    show: true,
  },
]
